import lang from './lang'
import native from './native'
import store from './store'


export default {
  store,
  lang,
  native
}
